export class CustomVocabulary {
    id: string;
    code: string;
    organizationCode: string;
    systemCode: string;
    channelCode: string;
    productCode: string;
    description: string;

    customTranslations: CustomTranslation[];
}

export class CustomTranslation {
    id: string;
    languageId: string;
    culture: string;
    translationText: string;
}

export class SystemVocabulary {
    id: string;
    code: string;
    wordTypeId: string;
    wordTypeDescription: string;
    description: string;

    systemTranslations: SystemTranslation[];
}

export class SystemTranslation {
    id: string;
    languageId: string;
    culture: string;
    translationText: string;
    isSystem: boolean;
}

export class Language {
    id: string;
    culture: string;
    description: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/resource.class.ts